import gql from 'graphql-tag';

const CREATE_SERVICE_CATALOG = gql`
  mutation createServiceCatalogItem($input: CreateServiceCatalogItemInput!) {
    createServiceCatalogItem(input: $input) {
      itemId
      name
      description
      category {
        categoryId
        name
      }
      itemType
      offerAsWorklogItem
      status
      taxable
      salesTax {
        taxId
        rates {
          rateId
          name
          rateValue
        }
      }
      sellingPrice {
        model
        details {
          value
          afterHoursValue
        }
      }
      costPrice {
        model
        details {
          value
          afterHoursValue
        }
      }
      serviceTypeItem {
        offeringType
        bundledItems {
          name
          itemId
          itemType
        }
        hourlyServiceTypeItem {
          itemId
          roundUpValue
        }
        redeemableServiceBundle {
          itemId
          applicableType
          applicableHours
          redeemableQuantity
        }
      }
    }
  }
`;

const CREATE_SERVICE_CATALOG_FROM_CONTRACT = gql`
  mutation createServiceCatalogItem($input: CreateServiceCatalogItemInput!) {
    createServiceCatalogItem(input: $input) {
      itemId
      name
      description
      category {
        categoryId
        name
      }
      itemType
      offerAsWorklogItem
      status
      taxable
      salesTax {
        taxId
      }
      sellingPrice {
        model
        details {
          value
          afterHoursValue
        }
      }
      costPrice {
        model
        details {
          value
          afterHoursValue
        }
      }
      serviceTypeItem {
        offeringType
        bundledItems {
          name
          itemId
          itemType
          sellingPrice {
            model
            details {
              value
              afterHoursValue
            }
          }
          costPrice {
            model
            details {
              value
              afterHoursValue
            }
          }
          serviceTypeItem {
            itemId
            offeringType
            hourlyServiceTypeItem {
              itemId
              roundUpValue
              defaultItem
            }
            redeemableServiceBundle {
              itemId
              applicableType
              applicableHours
              redeemableQuantity
            }
          }
        }
        hourlyServiceTypeItem {
          itemId
          roundUpValue
        }
        redeemableServiceBundle {
          itemId
          applicableType
          applicableHours
          redeemableQuantity
        }
      }
    }
  }
`;

const UPDATE_SERVICE_CATALOG = gql`
  mutation updateServiceCatalogItem($input: UpdateServiceCatalogItemInput!) {
    updateServiceCatalogItem(input: $input) {
      itemId
      name
      description
      category {
        categoryId
        name
      }
      itemType
      offerAsWorklogItem
      status
      taxable
      salesTax {
        taxId
      }
      sellingPrice {
        model
        details {
          value
          afterHoursValue
        }
      }
      costPrice {
        model
        details {
          value
          afterHoursValue
        }
      }
      serviceTypeItem {
        offeringType
        bundledItems {
          name
          itemId
          itemType
        }
        hourlyServiceTypeItem {
          itemId
          roundUpValue
        }
        redeemableServiceBundle {
          itemId
          applicableType
          applicableHours
          redeemableQuantity
        }
      }
    }
  }
`;

const DELETE_SERVICE_CATALOG_ITEMS = gql`
  mutation deleteServiceCatalogItems(
    $input: [ServiceCatalogItemIdentifierInput!]!
  ) {
    deleteServiceCatalogItems(input: $input)
  }
`;

const MARK_SERVICE_CATALOG_ACTIVE = gql`
  mutation markServiceCatalogItemsAsActive(
    $input: [ServiceCatalogItemIdentifierInput!]!
  ) {
    markServiceCatalogItemsAsActive(input: $input)
  }
`;

const MARK_SERVICE_CATALOG_INACTIVE = gql`
  mutation markServiceCatalogItemsAsInActive(
    $input: [ServiceCatalogItemIdentifierInput!]!
  ) {
    markServiceCatalogItemsAsInActive(input: $input)
  }
`;

export {
  CREATE_SERVICE_CATALOG,
  UPDATE_SERVICE_CATALOG,
  DELETE_SERVICE_CATALOG_ITEMS,
  MARK_SERVICE_CATALOG_ACTIVE,
  MARK_SERVICE_CATALOG_INACTIVE,
  CREATE_SERVICE_CATALOG_FROM_CONTRACT
};
